import { FC, memo } from 'react'

import { Request } from 'commons/utils/request'
import { ChoiceOption } from 'ui/types'

import { SingleSelectAutoSuggest } from '../SingleSelectAutoSuggest'
import { BankAccountSelectProps } from './BankAccountSelectProps'

const PLACEHOLDER = 'Start entering the bank account'

export const BankAccountSelect: FC<BankAccountSelectProps> = memo((props) => {
  const { value, defaultOption, filters, ...rest } = props
  const options: ChoiceOption[] = []

  if (defaultOption) {
    options.push(defaultOption)
  }

  const serverOptions = {
    filters,
    url: Request.urls.bank.bankAccountSearch,
    requestSearchString: 'searchString',
    limit: 500,
    mapper: (item) => ({ label: `${item.formattedNumber}`, value: item.id }),
    searchStringFilter: (searchString: string) => searchString.replaceAll('*', '')
  }

  return (
    <SingleSelectAutoSuggest
      noFirstRequest
      options={options}
      placeholder={PLACEHOLDER}
      serverOptions={serverOptions}
      value={value}
      {...rest}
    />
  )
})
